'use strict';

var $ = window.jQuery;
var ViewportTracker = require('../lib/ViewportTracker.js');
var AnimationEasing = require('../lib/AnimationEasing.js');

function init() {
	var config = {
		menu : '#menu',
		menuActive : false,
		menuCSS : 'hasMenuOpen',
		setupCSS : 'hasMenuSetup',
		subOpenedCSS : 'isOpen',
		subTarget : '.child-wrap',
		subTrigger : '.hasChild > a',
		triggers : '#menuTrigger--open, #menuTrigger--close, #menuOverlay',
		triggerEvent : 'click'
	};
	var $menu = $(config.menu);
	var $stateElem = $menu;
	var $subtarget = $menu.find(config.subTarget);
	
	function toggleMenu(event) {
		event.preventDefault();
		$stateElem.toggleClass(config.menuCSS);
	}
	function toggleSub(event) {
		event.preventDefault();
		var $target = $((event.target.tagName == 'SPAN') ? event.target.parentNode : event.target);
		$target.next().slideToggle(400, AnimationEasing.easeOutExpo);
		$target.parent('li').toggleClass(config.subOpenedCSS);
	}
	function begSub() {
		$stateElem.toggleClass(config.setupCSS);
		$subtarget.filter('.active').parents('li').addClass(config.subOpenedCSS)
		$subtarget.stop().not('.active').slideUp();
	}
	function endSub() {
		$stateElem.toggleClass(config.setupCSS);
		$subtarget.parents('li').removeClass(config.subOpenedCSS)
		$subtarget.stop().slideDown().attr('style', '');
	}
	function attachEventsWin() {
		if (config.menuActive === true) {
			return;
		}
		$(config.triggers).on(config.triggerEvent, toggleMenu);
		begSub();
		$menu.on('click.mobileMenu', config.subTrigger, toggleSub);
	}
	function detachEventsWin() {
		if (config.menuActive === false) {
			return;
		}
		$(config.triggers).off(config.triggerEvent, toggleMenu);
		endSub();
		$menu.off('click.mobileMenu');
	}
	function onViewportState() {
		var state = ViewportTracker.getState();
		$stateElem.removeClass(config.menuCSS);
		if (state == 'mobile') {
			attachEventsWin();
			config.menuActive = true;
		} else {
			detachEventsWin();
			config.menuActive = false;
		}
	}
	onViewportState();
	
	$(window).on('ViewportTracker:state', onViewportState);
}

var MobileMenu = {
	init: init
};


module.exports = MobileMenu;
